/**
 * @licence
 * Copyright 2021 ModBros OG
 * Licenced under apache Licence, Version 2.0
 */

/**
 * Do not edit directly!
 * Generated on Wed Oct 13 2021 19:02:58 GMT+0200 (Central European Summer Time)
 */

export const Default = {
  Family: 'var(--modbros-typography-default-family, Open Sans, Helvetica, sans-serif)',
  Weight: 'var(--modbros-typography-default-weight, 400)',
  Size: 'var(--modbros-typography-default-size, 1rem)',
  LineHeight: 'var(--modbros-typography-default-line-height, 1.375)',
  TextDecoration: 'var(--modbros-typography-default-text-decoration, none)',
  TextTransform: 'var(--modbros-typography-default-text-transform, none)'
};
export const DefaultEmphasized = {
  Family: 'var(--modbros-typography-default-emphasized-family, Open Sans, Helvetica, sans-serif)',
  Weight: 'var(--modbros-typography-default-emphasized-weight, 600)',
  Size: 'var(--modbros-typography-default-emphasized-size, 1rem)',
  LineHeight: 'var(--modbros-typography-default-emphasized-line-height, 1.375)',
  TextDecoration: 'var(--modbros-typography-default-emphasized-text-decoration, none)',
  TextTransform: 'var(--modbros-typography-default-emphasized-text-transform, none)'
};
export const Small = {
  Family: 'var(--modbros-typography-small-family, Open Sans, Helvetica, sans-serif)',
  Weight: 'var(--modbros-typography-small-weight, 300)',
  Size: 'var(--modbros-typography-small-size, 0.75rem)',
  LineHeight: 'var(--modbros-typography-small-line-height, 1.1667)',
  TextDecoration: 'var(--modbros-typography-small-text-decoration, none)',
  TextTransform: 'var(--modbros-typography-small-text-transform, none)'
};
export const SmallEmphasized = {
  Family: 'var(--modbros-typography-small-emphasized-family, Open Sans, Helvetica, sans-serif)',
  Weight: 'var(--modbros-typography-small-emphasized-weight, 600)',
  Size: 'var(--modbros-typography-small-emphasized-size, 0.75rem)',
  LineHeight: 'var(--modbros-typography-small-emphasized-line-height, 1.1667)',
  TextDecoration: 'var(--modbros-typography-small-emphasized-text-decoration, none)',
  TextTransform: 'var(--modbros-typography-small-emphasized-text-transform, none)'
};
export const Headline1 = {
  Family: 'var(--modbros-typography-headline-1-family, Rubik, sans-serif)',
  Weight: 'var(--modbros-typography-headline-1-weight, 500)',
  Size: 'var(--modbros-typography-headline-1-size, 4.75rem)',
  LineHeight: 'var(--modbros-typography-headline-1-line-height, 1.15)',
  TextDecoration: 'var(--modbros-typography-headline-1-text-decoration, none)',
  TextTransform: 'var(--modbros-typography-headline-1-text-transform, none)'
};
export const Headline2 = {
  Family: 'var(--modbros-typography-headline-2-family, Rubik, sans-serif)',
  Weight: 'var(--modbros-typography-headline-2-weight, 500)',
  Size: 'var(--modbros-typography-headline-2-size, 3rem)',
  LineHeight: 'var(--modbros-typography-headline-2-line-height, 1.125)',
  TextDecoration: 'var(--modbros-typography-headline-2-text-decoration, none)',
  TextTransform: 'var(--modbros-typography-headline-2-text-transform, none)'
};
export const Headline3 = {
  Family: 'var(--modbros-typography-headline-3-family, Rubik, sans-serif)',
  Weight: 'var(--modbros-typography-headline-3-weight, 700)',
  Size: 'var(--modbros-typography-headline-3-size, 2rem)',
  LineHeight: 'var(--modbros-typography-headline-3-line-height, 1.125)',
  TextDecoration: 'var(--modbros-typography-headline-3-text-decoration, none)',
  TextTransform: 'var(--modbros-typography-headline-3-text-transform, none)'
};
export const Headline4 = {
  Family: 'var(--modbros-typography-headline-4-family, Rubik, sans-serif)',
  Weight: 'var(--modbros-typography-headline-4-weight, 500)',
  Size: 'var(--modbros-typography-headline-4-size, 1.5rem)',
  LineHeight: 'var(--modbros-typography-headline-4-line-height, 1.1)',
  TextDecoration: 'var(--modbros-typography-headline-4-text-decoration, none)',
  TextTransform: 'var(--modbros-typography-headline-4-text-transform, none)'
};
export const Headline5 = {
  Family: 'var(--modbros-typography-headline-5-family, Rubik, sans-serif)',
  Weight: 'var(--modbros-typography-headline-5-weight, 500)',
  Size: 'var(--modbros-typography-headline-5-size, 1.25rem)',
  LineHeight: 'var(--modbros-typography-headline-5-line-height, 1.15)',
  TextDecoration: 'var(--modbros-typography-headline-5-text-decoration, none)',
  TextTransform: 'var(--modbros-typography-headline-5-text-transform, none)'
};
export const Headline6 = {
  Family: 'var(--modbros-typography-headline-6-family, Rubik, sans-serif)',
  Weight: 'var(--modbros-typography-headline-6-weight, 700)',
  Size: 'var(--modbros-typography-headline-6-size, 1rem)',
  LineHeight: 'var(--modbros-typography-headline-6-line-height, 1.2)',
  TextDecoration: 'var(--modbros-typography-headline-6-text-decoration, none)',
  TextTransform: 'var(--modbros-typography-headline-6-text-transform, none)'
};
export default {
  Default,
  DefaultEmphasized,
  Small,
  SmallEmphasized,
  Headline1,
  Headline2,
  Headline3,
  Headline4,
  Headline5,
  Headline6,
}